import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=233d24ea&scoped=true"
import script from "./page7.vue?vue&type=script&lang=js"
export * from "./page7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d24ea",
  null
  
)

export default component.exports